import de from '@/assets/locales/de.json'
import en from '@/assets/locales/en.json'
import fr from '@/assets/locales/fr.json'
import nl from '@/assets/locales/nl.json'
import { createI18n } from 'vue-i18n'

const messages = {
  en: en,
  fr: fr,
  de: de,
  nl: nl
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
export const t = i18n.global.t
